export default "__VITE_ASSET__Cezlsndb__"